export default __webpack_public_path__ + "assets/ThinCarat.770e.svg";